module.exports = __webpack_public_path__ + "static/img/custom-powder-coated-aluminum-sign-base.8f6c088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/general-frames/custom-powder-coated-aluminum-sign-base.jpg
// module id = 725
// module chunks = 0